// eslint-disable-next-line import/no-extraneous-dependencies
import {
    PayloadLexicalReactRenderer,
    type PayloadLexicalReactRendererContent,
} from '@atelier-disko/payload-lexical-react-renderer';

type Props = {
    className?: string;
    content: PayloadLexicalReactRendererContent;
};

export function RichTextRenderer({ content, className }: Props) {
    if (!content) {
        return null;
    }

    return (
        <div className={className}>
            <PayloadLexicalReactRenderer content={content} />
        </div>
    );
}

RichTextRenderer.displayName = 'RichTextRenderer';
